import React, { Fragment } from 'react';
import { BlogPostsSection } from "containers/AppCreative/Blog";
import Head from 'compat/Head';
import { ThemeProvider } from 'styled-components';
import { theme } from 'common/theme/appCreative';
import ResetCSS from 'common/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from 'containers/AppCreative/Navbar';
import PagesBanner from 'containers/AppCreative/PagesBanner';
import Footer from 'containers/AppCreative/Footer';
import GlobalStyle, { AppWrapper, ContentWrapper } from 'containers/AppCreative/appCreative.style';
import bannerImg from 'common/assets/image/appCreative/bannerImg_linok_team.png';
import bannerImgMobile from 'common/assets/image/appCreative/bannerImg_linok_team_mobile.png';

// Blog Posts Page
export default function BlogPosts() {
    return (
      <ThemeProvider theme={theme}>
        <Fragment>
          <Head>
            <title>Linok Blog | Linok: From Data to Decisions: Revolutionizing Milk Quality Monitoring</title>
            <link rel="icon" href="/favicon.png" />
            <meta name="description" content="Revolutionizing dairy management with cutting-edge technology, Linok provides real-time data analytics and insights to help farmers make smarter decisions, optimize herd health, boost production efficiency, and achieve sustainable growth" />
            <meta name="theme-color" content="#156b83" />
            <meta name="keywords" content="Linok, dairy, farming, data, sensors" />
          </Head>
          {/* end of head */}
          <ResetCSS />
          <GlobalStyle />
          {/* end of global and reset style */}
          {/* start app creative landing */}
          <AppWrapper>
            <Sticky top={0} innerZ={9999} activeClass="sticky-active">
              <Navbar />
            </Sticky>
            <ContentWrapper>
              <PagesBanner
                title={'Linok Blog'}
                subtitle={`Explore insights on dairy farming, AI-driven solutions, and industry trends. Stay informed, optimize herd health, and boost profitability with expert knowledge from Linok.`}
                bannerImg={bannerImg}
                bannerImgMobile={bannerImgMobile}
              />
              <BlogPostsSection />
            </ContentWrapper>
            <Footer />
          </AppWrapper>
        </Fragment>
      </ThemeProvider>
    );
  }
  